const es = {
  services: {
    seoTitle: "Servicios · Hotel Ciutat Martorell en Martorell",
    seoDesc: "Todos los servicios del hotel y de las habitaciones: Business Corner, restaurante My Bar, parking, gimnasio, WiFi gratuito, recepción 24 h y mucho más.",
    eyebrow: "Servicios",
    title: "Todo lo que necesitas para una estancia cómoda",
    hotelTitle: "Servicios del hotel",
    hotel: [
      "Aire acondicionado y calefacción",
      "Ascensores",
      "Buffet de desayuno diario",
      "Business Corner",
      "Consigna de equipajes",
      "Gimnasio",
      "Material audiovisual",
      "Parking",
      "Recepción 24 h",
      "Restaurante My Bar, abierto todos los días para comidas y cenas",
      "Servicio de habitaciones 24 h",
      "Salas de reunión y banquetes",
      "Servicio de lavandería / tintorería",
      "Servicio de impresión",
      "WiFi gratuito",
    ],
    roomsTitle: "En la habitación",
    rooms: [
      "Adaptadas a personas con movilidad reducida",
      "Aire acondicionado y calefacción individual",
      "Amenities en el baño",
      "Baño completo con ducha o bañera y/o bidé",
      "Escritorio",
      "Minibar",
      "Secador de pelo",
      "Televisión pantalla plana con entrada USB",
      "Teléfono en habitación y baño",
      "WiFi gratuito",
      "Cuna disponible",
      "Cama supletoria",
      "Habitaciones para no fumadores",
    ],
    fitness: {
      eyebrow: "Gimnasio",
      title: "Sala de fitness",
      text: "Mantén tu rutina durante tu estancia en nuestra sala de fitness, equipada con cinta de correr, bicicleta estática y mancuernas.",
      alts: ["Sala de fitness con bicicleta estática, cinta de correr y toallas", "Sala de fitness con cinta de correr, bicicleta y mancuernas frente al espejo"],
    },
    shop: {
      eyebrow: "Productos oficiales",
      title: "La pasión del fútbol, en recepción",
      text: "En nuestra recepción encontrarás productos oficiales del FC Barcelona y del Real Madrid. Llévate contigo la pasión de tu equipo.",
      note: "Venta exclusiva en recepción",
      cta: "Pregunta en recepción",
      clubs: [
        { name: "FC Barcelona", items: "Camisetas, gorras, bufandas, mochilas, balones y mucho más." },
        { name: "Real Madrid", items: "Camisetas, equipaciones, gorras, balones, bufandas y mucho más." },
      ],
    },
  },
  nav: {
    hotel: "El Hotel",
    rooms: "Habitaciones",
    services: "Servicios",
    corporate: "Empresas & Salas",
    events: "Eventos & Bodas",
    restaurant: "Restaurante",
    location: "Ubicación",
    biosphere: "Sostenibilidad",
    gallery: "Galería",
    blog: "Blog",
    contact: "Contacto",
    book: "Reservar directo",
    menu: "Menú",
    close: "Cerrar",
    call: "Llamar",
    map: "Ubicación",
    bookShort: "Reservar",
  },
  hero: {
    availability: "Consultar disponibilidad",
    checkin: "Entrada",
    checkout: "Salida",
    adults: "Adultos",
    children: "Niños",
    promo: "Código promo",
    promoPlaceholder: "Opcional",
    bestPrice: "Mejor precio garantizado reservando aquí",
    scroll: "Desplázate",
  },
  attrs: [
    { t: "Mejor precio garantizado", d: "Reservando directo" },
    { t: "Cancelación flexible", d: "Según tarifa" },
    { t: "Desayuno buffet", d: "De 06:30 a 10:30" },
    { t: "Parking privado", d: "Con suplemento, según disponibilidad" },
    { t: "100 m Renfe & FGC", d: "30 min Barcelona" },
  ],
  marquee: ["Martorell", "30 min Barcelona", "Montserrat", "Renfe & FGC a 100 m", "Zona empresarial SEAT-CUPRA", "Confort 4 estrellas", "92 habitaciones", "Reserva directa"],
  home: {
    presEyebrow: "El hotel",
    stats: [
      { n: "92", l: "habitaciones standard" },
      { n: "100 m", l: "de Renfe y FGC" },
      { n: "30 min", l: "de Barcelona y el aeropuerto" },
      { n: "180", l: "personas en el salón principal" },
    ],
    roomsEyebrow: "Habitaciones",
    roomsTitle: "Descanso a medida",
    roomsText: "Dos tipologías pensadas para el viajero de negocios, las familias y las estancias largas.",
    roomsCta: "Ver todas las habitaciones",
    from: "Desde",
    detail: "Ver detalle",
    corpEyebrow: "Empresas & reuniones",
    corpTitle: "Un hub corporativo|a 5 minutos de SEAT-CUPRA",
    corpFeatures: ["3 salas de reuniones", "Hasta 180 personas", "Conexión WiFi y material audiovisual", "Coffee breaks y almuerzos ejecutivos"],
    corpCta: "Solicitar presupuesto",
    corpSecondary: "Ver salas",
    restEyebrow: "Gastronomía",
    restCta: "Descubrir el restaurante",
    locEyebrow: "Ubicación",
    locCta: "Cómo llegar",
    galleryEyebrow: "Galería",
    galleryCta: "Ver galería completa",
    directEyebrow: "Reserva directa",
    directTitle: "Reservar aquí siempre sale a cuenta",
    directItems: [
      { t: "Mejor precio online", d: "Ninguna agencia te ofrecerá una tarifa más baja que nuestra web." },
      { t: "Condiciones flexibles", d: "Tarifas con cancelación gratuita y pago en el hotel." },
      { t: "Atención directa", d: "Hablas con el equipo del hotel, sin intermediarios, antes y después de tu estancia." },
      { t: "Detalles de bienvenida", d: "Late check-out sujeto a disponibilidad y ventajas exclusivas para clientes directos." },
    ],
    testimonialsEyebrow: "Opiniones",
    testimonials: [
      { q: "Ubicación perfecta para trabajar en la zona industrial. Habitaciones silenciosas y desayuno completo. Repetimos cada mes.", a: "Marc V.", r: "Viaje de empresa" },
      { q: "Celebramos la comunión de nuestra hija en el salón y todo salió impecable. El equipo se ocupó de cada detalle.", a: "Laura & Jordi", r: "Celebración familiar" },
      { q: "Tren a 2 minutos a pie y Barcelona en media hora. Una base tranquila y bien cuidada para visitar la ciudad y Montserrat.", a: "Claire D.", r: "Escapada" },
    ],
    contactEyebrow: "Hablemos",
    contactCta: "Contactar",
    rfpCta: "Pedir presupuesto",
  },
  rooms: {
    eyebrow: "Habitaciones",
    surface: "Superficie",
    occupancy: "Ocupación",
    bed: "Cama",
    bath: "Baño",
    features: "Equipamiento",
    guests: "personas",
    book: "Reservar esta habitación",
    all: "Todas las habitaciones",
    photosEyebrow: "Galería",
    photosTitle: "Habitación y baño",
    photosCount: "fotos",
    featureLabels: {
      wifi: "Wifi de alta velocidad",
      ac: "Climatización",
      tv: "TV",
      desk: "Escritorio de trabajo",
      minibar: "Minibar",
      hairdryer: "Secador de pelo",
      crib: "Cuna disponible",
      extra_bed: "Cama supletoria",
      accessible: "Adaptada",
      nonsmoking: "No fumadores",
    },
    servicesEyebrow: "Servicios",
    family: {
      eyebrow: "Viajas en familia",
      title: "Opciones para familias",
      beds: { t: "Cama supletoria (triple)", d: "Convierte tu habitación en triple con una cama supletoria. Gratuita para menores de 12 años." },
      crib: { t: "Cuna gratuita", d: "Cunas disponibles sin coste para los más pequeños." },
      note: "Ambas opciones están sujetas a disponibilidad; solicítalas con antelación al reservar.",
    },
    servicesTitle: "Tenemos todo lo que necesitas",
    services: [
      { t: "Desayuno buffet", d: "Producto local, bollería artesana y opciones saludables cada mañana." },
      { t: "Parking privado", d: "Con suplemento, según disponibilidad." },
      { t: "Wifi de fibra", d: "Conexión simétrica en todo el hotel, sin coste adicional." },
      { t: "Recepción 24 h", d: "Equipo disponible a cualquier hora para lo que necesites." },
      { t: "Sala de Fitness", d: "Mantén tu rutina durante tu estancia." },
      { t: "Restaurante & bar", d: "Menú ejecutivo, carta mediterránea y copas tranquilas." },
    ],
    notFound: "Habitación no encontrada",
  },
  corporate: {
    eyebrow: "Empresas",
    title: "Su base de operaciones en el corredor industrial del Llobregat",
    pillars: [
      { t: "Tarifas corporativas", d: "Precios negociados para empresas con estancias frecuentes y facturación centralizada." },
      { t: "Salas de reuniones", d: "Tres espacios modulables, de 12 a 180 personas." },
      { t: "Trabajar y descansar", d: "Escritorio en todas las habitaciones, WiFi y desayuno desde primera hora." },
      { t: "Catering ejecutivo", d: "Coffee breaks, almuerzos de trabajo y cenas de equipo en el propio hotel." },
    ],
    salasEyebrow: "Salas de reuniones",
    photosTitle: "Sala y eventos",
    salasTitle: "Espacios que se adaptan a su agenda",
    salasCta: "Ver todas las salas y capacidades",
    formEyebrow: "Tarifa empresa",
    formTitle: "Solicite su tarifa corporativa",
    formText: "Cuéntenos cuántas noches al año necesita su equipo y le prepararemos una propuesta en menos de 24 horas.",
    capacityTitle: "Capacidades por montaje",
    capacityLabels: { teatro: "Teatro", escuela: "Escuela", u: "Forma U", imperial: "Imperial", coctel: "Cóctel", banquete: "Banquete" },
    equipmentLabels: {
      wifi: "Wifi de fibra", proyector: "Proyector & pantalla", flipchart: "Flipchart", pizarra: "Pizarra",
      coffee_break: "Coffee break", agua: "Agua mineral", escritura: "Material de escritura", luz_natural: "Luz natural", panelable: "Panelable",
    },
    area: "Superficie",
    people: "pers.",
    upTo: "Hasta",
    requestRoom: "Solicitar presupuesto de esta sala",
    salasIntro: "Todas las salas disponen de wifi de fibra, climatización independiente, equipamiento audiovisual y servicio de coffee break. Le ayudamos a elegir el montaje ideal.",
    servicesTitle: "Servicios para su evento",
    services: ["Coffee break de bienvenida y media mañana", "Almuerzo ejecutivo o buffet de trabajo", "Alojamiento para ponentes y asistentes", "Parking para asistentes", "Soporte técnico durante el evento", "Secretaría y material de escritura"],
    otherRooms: "Otras salas",
    notFound: "Sala no encontrada",
  },
  events: {
    eyebrow: "Eventos & celebraciones",
    title: "Los grandes días merecen un lugar a la altura",
    intro: "Bodas, comuniones, aniversarios y encuentros de grupo en un salón de 220 m² con luz natural, cocina propia y 92 habitaciones para que nadie tenga que conducir de vuelta.",
    types: [
      { key: "weddings", t: "Bodas", d: "Banquetes de hasta 150 invitados, cóctel de bienvenida y habitación nupcial de cortesía.", cta: "Descubrir bodas" },
      { key: "celebrations", t: "Celebraciones", d: "Comuniones, bautizos, cumpleaños y aniversarios con menús a medida para todas las edades.", cta: "Ver celebraciones" },
      { key: "groups", t: "Grupos", d: "Equipos deportivos, viajes organizados y peregrinos a Montserrat con condiciones especiales.", cta: "Grupos & viajes" },
    ],
    stepsEyebrow: "Cómo lo hacemos",
    steps: [
      { t: "Nos conocemos", d: "Visita al hotel, escuchamos su idea y proponemos espacios y menús." },
      { t: "Propuesta a medida", d: "Presupuesto cerrado en 48 h, sin sorpresas, con degustación previa para bodas." },
      { t: "El gran día", d: "Un coordinador dedicado se ocupa de tiempos, proveedores y de que usted solo disfrute." },
    ],
    formEyebrow: "Cuéntenos su evento",
    formTitle: "Empecemos a planificarlo",
    weddings: {
      title: "Bodas en Martorell, a media hora de Barcelona",
      intro: "Un salón panelable con luz natural para el banquete, terraza para el cóctel y habitaciones para los novios y sus invitados. Cocina mediterránea propia y un coordinador dedicado desde el primer café hasta el último baile.",
      includes: ["Cóctel de bienvenida", "Banquete con menú degustación previo", "Habitación nupcial de cortesía", "Tarifas especiales para invitados", "Barra libre y DJ opcional"],
    },
    celebrations: {
      title: "Comuniones, bautizos y aniversarios",
      intro: "Celebraciones familiares con menús pensados para mayores y pequeños, espacio para animación infantil y la tranquilidad de tenerlo todo bajo el mismo techo.",
      includes: ["Menús infantiles y para adultos", "Espacio para animación", "Decoración a medida", "Tarta personalizada", "Zona de fotografías", "Habitaciones para familiares"],
    },
    groups: {
      title: "Grupos, equipos y viajes organizados",
      intro: "Alojamiento para grupos de 10 a 180 personas con desayuno anticipado, cenas de grupo y check-in ágil. Punto de partida ideal para Montserrat y Barcelona.",
      includes: ["Tarifas de grupo desde 10 habitaciones", "Desayuno anticipado a demanda", "Cenas y picnics de grupo", "Check-in colectivo"],
    },
    includesTitle: "Incluido en la propuesta",
    back: "Todos los eventos",
  },
  restaurant: {
    eyebrow: "My Bar",
    title: "Cocina mediterránea de mercado",
    hoursTitle: "Horarios",
    breakfast: "Desayuno",
    lunch: "Almuerzo",
    dinner: "Cena",
    menuEyebrow: "Propuestas",
    menus: [
      { t: "Desayuno buffet", d: "Bollería artesana, fruta fresca, embutidos catalanes, huevos al momento y café de especialidad.", p: "06:30 – 10:30" },
      { t: "Menú ejecutivo", d: "De lunes a viernes al mediodía. Tres platos de mercado con pan, bebida y café.", p: "Consultar precio" },
      { t: "Carta mediterránea", d: "Arroces, pescado del día, carnes a la brasa y postres de la casa con vinos del Penedès.", p: "Cenas y fines de semana" },
      { t: "Menús de grupo", d: "Propuestas cerradas para empresas, celebraciones y grupos de viaje a partir de 10 comensales.", p: "A medida" },
    ],
    reserveTitle: "Reservar mesa",
    reserveText: "Llámanos y te confirmamos la mesa al momento.",
    reserveCta: "Llamar al restaurante",
    reserveTap: "Toca para llamar",
    wineEyebrow: "Bodega",
    wineTitle: "Vinos del Penedès y de toda Cataluña",
    wineText: "Una carta corta y honesta que prioriza pequeñas bodegas de la comarca: cavas, xarel·los y garnachas que acompañan la cocina de temporada.",
  },
  location: {
    eyebrow: "Ubicación & conectividad",
    title: "En el centro de todo lo que importa",
    pois: [
      { name: "Estación Renfe / FGC Martorell Enllaç", dist: "100 m", time: "2 min a pie", mode: "walk" },
      { name: "Sede SEAT-CUPRA y polígonos industriales", dist: "2,5 km", time: "5 min en coche", mode: "car" },
      { name: "Monasterio y Parque Natural de Montserrat", dist: "19 km", time: "20 min en coche / cremallera", mode: "car" },
      { name: "Centro de Barcelona (Pl. Espanya / Catalunya)", dist: "28 km", time: "30 min en tren directo o A-2", mode: "train" },
      { name: "Aeropuerto Barcelona-El Prat (BCN)", dist: "32 km", time: "25 min por autopista", mode: "plane" },
      { name: "Circuit de Barcelona-Catalunya", dist: "45 km", time: "40 min por AP-7", mode: "car" },
    ],
    faqEyebrow: "Preguntas frecuentes",
    faqTitle: "Cómo llegar y moverse",
    mapCta: "Abrir en Google Maps",
    addressTitle: "Dirección",
    transportTitle: "Transporte",
    transportItems: [
      { t: "En tren", d: "Renfe R4 y FGC (Martorell Enllaç / Martorell Central) a 100 m. Barcelona en 30 min." },
      { t: "En coche", d: "Salida directa desde la A-2 y la AP-7." },
      { t: "Desde el aeropuerto", d: "25 minutos por autopista. Taxi o alquiler de coche recomendado." },
    ],
  },
  gallery: {
    eyebrow: "Galería",
    title: "El hotel, en imágenes",
    all: "Todo",
    cats: { habitaciones: "Habitaciones", restaurante: "Restaurante", salas: "Salas de reuniones", eventos: "Eventos", fitness: "Sala de fitness", comunes: "Zonas comunes" },
  },
  blog: {
    eyebrow: "Blog & guías",
    title: "Martorell, Barcelona y Montserrat con calma",
    read: "min de lectura",
    readMore: "Leer artículo",
    back: "Volver al blog",
    related: "Artículos relacionados",
    notFound: "Artículo no encontrado",
  },
  contact: {
    eyebrow: "Contacto",
    title: "Hablemos de su estancia o su evento",
    text: "Respondemos en menos de 24 horas laborables. Para reservas de habitaciones, utilice nuestro motor de reserva directa con el mejor precio garantizado.",
    phone: "Teléfono",
    email: "Email",
    address: "Dirección",
    hours: "Recepción 24 horas",
    formEyebrow: "Formulario",
    formTitle: "¿En qué podemos ayudarle?",
  },
  form: {
    type: "Tipo de solicitud",
    types: { contacto: "Consulta general", empresa: "Tarifa corporativa", salas: "Presupuesto salas / reuniones", evento: "Boda / celebración / grupo", restaurante: "Reserva restaurante" },
    name: "Nombre y apellidos",
    company: "Empresa / organización",
    email: "Email",
    phone: "Teléfono",
    nights: "Noches al año (aprox.)",
    guests: "Personas / comensales",
    date: "Fecha prevista",
    attendees: "Número de asistentes",
    eventType: "Tipo de evento",
    eventTypes: ["Boda", "Comunión / bautizo", "Aniversario / cumpleaños", "Reunión / formación", "Convención", "Grupo de viaje", "Otro"],
    setup: "Montaje preferido",
    setups: ["Teatro", "Escuela", "Forma U", "Imperial", "Cóctel", "Banquete"],
    catering: "Catering",
    caterings: ["Coffee break", "Almuerzo ejecutivo", "Cena", "Sin catering"],
    lodging: "¿Necesita alojamiento?",
    lodgings: ["Sí", "No", "Por confirmar"],
    message: "Comentarios",
    messagePlaceholder: "Cuéntenos lo que necesita…",
    consent: "He leído y acepto la política de privacidad y el tratamiento de mis datos para atender esta solicitud.",
    submit: "Enviar solicitud",
    sending: "Enviando…",
    success: "Solicitud enviada. Le responderemos en menos de 24 h.",
    error: "No se ha podido enviar. Inténtelo de nuevo o llámenos.",
    required: "Campo obligatorio",
    invalidEmail: "Email no válido",
    consentRequired: "Debe aceptar la política de privacidad",
    select: "Seleccionar",
  },
  footer: {
    tagline: "Hotel 4 estrellas en Martorell. Descanso, trabajo y celebraciones a 30 minutos de Barcelona.",
    explore: "Explorar",
    business: "Empresas",
    guides: "Guías",
    legal: "Legal",
    contact: "Contacto",
    legalNotice: "Aviso legal",
    privacy: "Privacidad",
    cookies: "Cookies",
    cookieSettings: "Configurar cookies",
    rights: "Todos los derechos reservados.",
    registration: "Registro turístico",
    newsletter: "Reciba ofertas directas",
    newsletterText: "Solo escribimos cuando hay algo que merece la pena.",
    subscribe: "Suscribirme",
    subscribed: "Gracias, le mantendremos informado.",
    directBook: "Reserva directa · Mejor precio garantizado",
  },
  legal: {
    legal: { title: "Aviso legal", date: "octubre de 2026", sections: [
      ["Datos identificativos", "En cumplimiento de lo dispuesto en la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico (LSSI-CE), se informa de los siguientes datos:\nTitular: EYE STAR, S.L.\nNombre comercial: Hotel Ciutat Martorell\nNIF: B87171740\nDomicilio social: Avda. de la Industria, 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid), España\nDomicilio del establecimiento: Avda. Pau Claris, s/n, 08760 Martorell (Barcelona), España\nTeléfono: +34 937 745 160\nCorreo electrónico: info@hotel-martorell.com\nSitio web: www.hotel-martorell.com\nDatos registrales: Registro Mercantil de Madrid, Tomo 32963, Folio 138, Hoja M-593334, Inscripción 1.ª."],
      ["Objeto", "El presente Aviso Legal regula el acceso, navegación y utilización del sitio web www.hotel-martorell.com, así como las responsabilidades derivadas de la utilización de sus contenidos y, en su caso, de los servicios que puedan ofrecerse a través del mismo.\nEl acceso y navegación por el sitio web atribuyen la condición de usuario e implican la aceptación de las condiciones recogidas en el presente Aviso Legal."],
      ["Condiciones de uso", "El usuario se compromete a utilizar el sitio web de conformidad con la legislación vigente, la buena fe, el orden público y el presente Aviso Legal.\nEl usuario deberá abstenerse de utilizar el sitio web con fines ilícitos o contrarios a lo establecido en este Aviso Legal, así como de realizar cualquier actuación que pueda dañar, inutilizar, sobrecargar o deteriorar el sitio web, sus contenidos o los sistemas y equipos que lo soportan."],
      ["Propiedad intelectual e industrial", "Todos los contenidos del sitio web, incluyendo, a título enunciativo y no limitativo, textos, fotografías, imágenes, gráficos, logotipos, iconos, diseño, estructura, código fuente y demás elementos que forman parte del sitio web, son titularidad de EYE STAR, S.L. o se utilizan con la correspondiente autorización de sus legítimos titulares.\nDichos contenidos se encuentran protegidos por la normativa vigente en materia de propiedad intelectual e industrial.\nQueda prohibida la reproducción, distribución, comunicación pública, transformación o cualquier otra forma de explotación, total o parcial, de los contenidos del sitio web sin la autorización previa y expresa de EYE STAR, S.L., salvo en los casos legalmente permitidos."],
      ["Responsabilidad", "EYE STAR, S.L. procurará que los contenidos del sitio web sean correctos y estén actualizados. No obstante, no garantiza la inexistencia de errores u omisiones ni se responsabiliza de los daños o perjuicios que pudieran derivarse de la utilización de la información contenida en el sitio web cuando estos sean consecuencia de circunstancias ajenas a su control.\nEYE STAR, S.L. tampoco garantiza la disponibilidad y continuidad del funcionamiento del sitio web, pudiendo producirse interrupciones por causas técnicas, de mantenimiento o por circunstancias ajenas a su control.\nEl sitio web puede contener enlaces a páginas web de terceros. EYE STAR, S.L. no asume responsabilidad alguna por los contenidos, servicios, funcionamiento o políticas de privacidad de dichos sitios web externos."],
      ["Protección de datos personales", "El tratamiento de los datos personales que puedan recabarse a través de este sitio web se realizará de conformidad con la normativa vigente en materia de protección de datos personales.\nLa información relativa al responsable del tratamiento, las finalidades del tratamiento, las bases jurídicas, los destinatarios, los plazos de conservación y los derechos que pueden ejercer los usuarios se encuentra disponible en la Política de Privacidad del sitio web."],
      ["Cookies", "Este sitio web puede utilizar cookies y tecnologías similares.\nLa información relativa a las cookies utilizadas, sus finalidades, los terceros que puedan intervenir y la forma en que el usuario puede gestionar sus preferencias se encuentra disponible en la Política de Cookies.\nLas cookies que no sean estrictamente necesarias se utilizarán de conformidad con la normativa aplicable y, cuando resulte necesario, previa obtención del consentimiento del usuario."],
      ["Comunicaciones comerciales", "Cuando el usuario haya prestado su consentimiento para recibir comunicaciones comerciales por medios electrónicos, estas se realizarán de conformidad con la legislación vigente.\nEl usuario podrá oponerse al envío de comunicaciones comerciales en cualquier momento mediante los mecanismos habilitados al efecto en cada comunicación."],
      ["Modificaciones", "EYE STAR, S.L. se reserva el derecho de modificar, actualizar o eliminar, en cualquier momento y sin necesidad de previo aviso, los contenidos y servicios ofrecidos a través del sitio web, así como el presente Aviso Legal.\nLas modificaciones serán aplicables desde el momento de su publicación en el sitio web."],
      ["Legislación aplicable y jurisdicción", "La relación entre EYE STAR, S.L. y el usuario se regirá por la legislación española.\nPara la resolución de cualquier controversia que pudiera surgir en relación con el acceso o utilización del sitio web, serán competentes los juzgados y tribunales que correspondan de conformidad con la normativa aplicable.\nCuando el usuario tenga la condición de consumidor o usuario, se respetarán las normas imperativas relativas a competencia judicial y protección de consumidores que resulten aplicables."],
    ]},
    privacy: { title: "Política de privacidad", date: "18 de julio de 2025", sections: [
      ["Responsable del tratamiento", "Razón social: EYE STAR SL\nNIF: B87171740\nDominio: https://www.hotel-martorell.com/\nDirección postal: Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid)\nCorreo electrónico: administracion@hotel-martorell.com\nTeléfono: +34 937 745 160"],
      ["Protección de datos", "De conformidad con la normativa vigente y aplicable en protección de datos de carácter personal, le informamos de que sus datos serán incorporados al sistema de tratamiento titularidad de EYE STAR SL, con NIF B87171740 y domicilio social en Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid). A continuación se facilita la información de los tratamientos realizados."],
      ["Gestión de reservas online de alojamiento", "Finalidad: registro y gestión de las reservas online de alojamiento.\nPlazo de conservación: 3 años (Orden INT/1922/2003, de 3 de julio, sobre libros-registro y partes de entrada de viajeros en establecimientos de hostelería y otros análogos).\nBase legítima: el consentimiento del interesado.\nDatos básicos: nombre y apellidos, teléfono, NIF, dirección electrónica, datos económicos o de seguros.\nDatos sensibles: datos relativos a menores.\nCesiones: sus datos serán comunicados, en caso de ser necesario, a la Agencia Tributaria, bancos y cajas, Fuerzas y Cuerpos de Seguridad y autoridades competentes, con la finalidad de cumplir con las obligaciones administrativas y de seguridad establecidas en la normativa aplicable. La base legitimadora de la cesión es el cumplimiento de una ley."],
      ["Acciones comerciales (formulario web)", "Finalidad: captación, registro y tratamiento de datos para atender sus consultas y/o solicitudes, así como para publicidad y prospección comercial.\nPlazo de conservación: mientras se mantenga el consentimiento prestado, salvo obligación legal.\nBase legítima: el consentimiento del interesado.\nDatos básicos: nombre y apellidos, dirección electrónica."],
      ["Gestión de usuarios web", "Finalidad: captación, registro y tratamiento de datos del usuario.\nPlazo de conservación: mientras se mantenga el consentimiento prestado, salvo obligación legal.\nBase legítima: el consentimiento del interesado.\nDatos básicos: nombre y apellidos, dirección electrónica."],
      ["Instalación de cookies", "Finalidad: gestión e instalación de las cookies.\nPlazo de conservación: mientras se mantenga el consentimiento prestado.\nBase legítima: el consentimiento del interesado.\nDatos básicos: dirección electrónica, dirección IP."],
      ["Newsletter", "Finalidad: gestión de la suscripción a la newsletter para realizar los envíos correspondientes.\nPlazo de conservación: mientras se mantenga el consentimiento prestado.\nBase legítima: el consentimiento del interesado.\nDatos básicos: nombre y apellidos, dirección electrónica."],
      ["Gestión del formulario web", "Finalidad: atender sus consultas y/o solicitudes.\nPlazo de conservación: mientras se mantenga el consentimiento prestado.\nBase legítima: el consentimiento del interesado.\nDatos básicos: nombre y apellidos, dirección electrónica, dirección IP."],
      ["Derechos de los interesados", "Puede ejercer los derechos de acceso, rectificación, limitación, supresión, portabilidad y oposición al tratamiento de sus datos de carácter personal, así como el derecho a no ser objeto de decisiones automatizadas (incluida la elaboración de perfiles) y a retirar el consentimiento prestado:\n• Acceso: obtener confirmación sobre si se tratan sus datos y, en tal caso, los datos concretos y la información legal del tratamiento.\n• Rectificación: que se modifiquen los datos inexactos o incompletos.\n• Limitación: que se limiten los fines del tratamiento en determinados supuestos.\n• Supresión: que se supriman sus datos, salvo las excepciones previstas en el RGPD.\n• Portabilidad: recibir sus datos en un formato estructurado, de uso común y lectura mecánica, y transmitirlos a otro responsable.\n• Oposición: que no se traten sus datos o cese su tratamiento en los supuestos previstos.\n• A no ser objeto de decisiones automatizadas, incluida la elaboración de perfiles.\n• Retirada del consentimiento: en cualquier momento y de forma gratuita."],
      ["Ejercicio de los derechos", "Para ejercer estos derechos puede presentar un escrito en la dirección Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid), a la atención de EYE STAR SL, o enviar un correo electrónico a administracion@hotel-martorell.com. El interesado deberá identificarse fehacientemente; en caso de dudas sobre su identidad, se le podrá solicitar que subsane la petición. La solicitud puede realizarla un representante legal o voluntario debidamente identificado y autorizado. Debe concretarse el derecho o derechos que se desean ejercer e indicar una dirección a efectos de notificaciones, aportando los documentos acreditativos necesarios. Nunca se facilitará información por teléfono."],
      ["Reclamación ante la autoridad de control", "Tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos si considera que un hecho pueda suponer un incumplimiento de la normativa aplicable en materia de protección de datos."],
      ["Medidas de seguridad", "EYE STAR SL se compromete a adoptar las medidas técnicas y organizativas necesarias, acordes al nivel de riesgo de los tratamientos realizados, de forma que garanticen la integridad, confidencialidad y disponibilidad de los datos."],
    ]},
    cookies: { title: "Política de cookies", sections: [
      ["Qué son", "Las cookies son pequeños archivos que se almacenan en su dispositivo al navegar y permiten recordar preferencias o medir el uso del sitio."],
      ["Cookies que utilizamos", "Cookies técnicas necesarias para el funcionamiento (idioma, sesión de administración y el recuerdo de tu elección de cookies) y, solo con tu consentimiento, cookies analíticas de Google Analytics 4 (_ga, _ga_*; duración máxima 13 meses) con IP anonimizada para conocer cómo se usa la web y mejorarla."],
      ["Terceros", "El mapa integrado de Google Maps y el motor de reservas externo pueden instalar sus propias cookies, sujetas a sus políticas."],
      ["Cómo gestionarlas", "Puede configurar su navegador para bloquear o eliminar cookies. Ello puede afectar a algunas funcionalidades del sitio."],
      ["Gestionar tu consentimiento", "Al entrar por primera vez puedes aceptar, rechazar o configurar las cookies por categorías. Puedes cambiar tu elección en cualquier momento desde el enlace «Configurar cookies» del pie de página. Si rechazas las cookies analíticas, Google Analytics funciona en modo sin cookies (Consent Mode) y solo recibe señales anónimas."],
    ]},
    updated: "Última actualización",
  },
  consent: {
    eyebrow: "Cookies",
    title: "Tu privacidad, a tu manera",
    text: "Usamos cookies propias necesarias y, solo si lo aceptas, cookies analíticas (Google Analytics) para entender cómo se usa la web y mejorarla. Puedes cambiar tu elección cuando quieras desde «Configurar cookies», en el pie de página.",
    more: "Política de cookies",
    acceptAll: "Aceptar todas",
    reject: "Rechazar",
    configure: "Configurar",
    save: "Guardar selección",
    close: "Cerrar",
    always: "Siempre activas",
    necessary: { t: "Necesarias", d: "Imprescindibles para que la web funcione: idioma, seguridad y el recuerdo de tu elección de cookies." },
    analytics: { t: "Analíticas", d: "Google Analytics con IP anonimizada, para medir visitas y mejorar la web. Si las rechazas, solo se envían señales anónimas sin cookies." },
    marketing: { t: "Marketing", d: "Para medir campañas y personalizar anuncios de Google. Actualmente no utilizamos ninguna cookie de este tipo." },
  },
  notFound: { title: "Página no encontrada", text: "La página que busca no existe o ha cambiado de dirección.", cta: "Volver al inicio" },
  admin: {
    login: "Acceso al panel",
    email: "Email",
    password: "Contraseña",
    enter: "Entrar",
    logout: "Salir",
    panel: "Panel de contenidos",
    tabs: { stats: "Estadísticas", leads: "Solicitudes", content: "Textos", rooms: "Habitaciones", meeting: "Salas", faqs: "FAQs", gallery: "Galería", blog: "Blog", survey: "Sostenibilidad", settings: "Datos del hotel" },
    save: "Guardar",
    saved: "Guardado",
    add: "Añadir",
    delete: "Eliminar",
    status: { nuevo: "Nuevo", en_proceso: "En proceso", cerrado: "Cerrado" },
    noLeads: "Todavía no hay solicitudes.",
    resend: "Reenviar aviso",
    resendOk: "Aviso reenviado a",
    resendFail: "No se pudo enviar el aviso",
    notifySent: "Aviso por email enviado",
    notifyFailed: "El aviso por email falló",
    notifyUnknown: "Sin registro de envío",
  },
  common: {
    seeMore: "Ver más",
    bookNow: "Reservar ahora",
    call: "Llamar al hotel",
    placeholderNote: "Fotografía provisional",
  },
  pages: {
    rooms: {
      seoTitle: "Habitaciones en Martorell · Doble y Twin de 21 m²",
      seoDesc: "Habitaciones Doble y Twin con wifi de fibra, escritorio y desayuno buffet. Doble y Doble Twin. Reserva directa al mejor precio.",
      heroTitle: ["Habitaciones", "pensadas para descansar"],
      heroText: "92 habitaciones diseñadas para el descanso absoluto del viajero de negocios y de ocio.",
    },
    roomDetailSuffix: "Habitaciones",
    corporate: {
      seoTitle: "Hotel para empresas y salas de reuniones en Martorell",
      seoDesc: "Tarifas corporativas, 3 salas de reuniones hasta 180 personas y alojamiento a 5 min de SEAT-CUPRA y los polígonos de Martorell. Solicite presupuesto en 24 h.",
      heroTitle: ["Su base de operaciones", "en el corredor del Llobregat"],
    },
    meetingRooms: {
      seoTitle: "Salas de reuniones y eventos en Martorell",
      seoDesc: "3 salas con luz natural de 35 a 220 m² para reuniones, formaciones y convenciones de 12 a 180 personas. Audiovisuales, fibra y coffee break.",
      heroTitle: ["Tres salas,", "infinitos montajes"],
    },
    events: {
      seoTitle: "Bodas, celebraciones y grupos en Martorell",
      heroTitle: ["Los grandes días merecen", "un lugar a la altura"],
      stepsTitle: "Tres pasos, cero preocupaciones",
    },
    restaurant: {
      seoTitle: "Restaurante en Martorell · Cocina mediterránea",
      heroTitle: ["Cocina mediterránea", "de mercado"],
    },
    location: {
      seoTitle: "Ubicación · Hotel en Martorell a 30 min de Barcelona",
      heroTitle: ["En el centro de todo", "lo que importa"],
      distancesTitle: "Distancias y tiempos",
    },
    gallery: {
      seoDesc: "Fotografías del Hotel Ciutat Martorell 4★ en Martorell: habitaciones Doble y Twin, baños, salas de reuniones, Salón de Banquetes, restaurante My Bar, zonas comunes y entorno.",
      biosphereNote: "El Hotel Ciutat Martorell cuenta con la certificación Biosphere de turismo sostenible. Consulta todas nuestras acciones y compromisos en materia de sostenibilidad directamente en nuestro perfil oficial.",
    },
    blog: { seoDesc: "Guías prácticas sobre Martorell, Barcelona y Montserrat: cómo llegar en tren o coche, qué visitar, dónde comer y consejos para viajeros de empresa y familias." },
    faq: { eyebrow: "Preguntas frecuentes", home: "Lo que suelen preguntarnos", rooms: "Sobre las habitaciones", corporate: "Sobre reuniones y empresas", events: "Sobre bodas, celebraciones y grupos", restaurant: "Sobre el restaurante" },
    biosphere: { seoTitle: "Sostenibilidad · Certificación Biosphere" },
    contact: { hoursValue: "Check-in 15:00 · Check-out 12:00" },
    seal: { sustainableTourism: "Turismo sostenible", certifiedBy: "Certificación", viewCert: "Ver certificación" },
    bookingCta: {
      eyebrow: "Reserva directa",
      rooms: { title: "Reserva al mejor precio garantizado", text: "Reservando directamente en la web oficial consigues la mejor tarifa, sin intermediarios ni comisiones." },
      location: { title: "A 30 minutos de Barcelona y Montserrat", text: "Alójate junto a las estaciones de Renfe y FGC, con el aeropuerto a 30 minutos. Reserva directa al mejor precio garantizado." },
    },
    blogPost: {
      sidebarTitle: "Duerme a 100 m del tren",
      cta: {
        eyebrow: "Reserva directa",
        secondary: "Pedir presupuesto",
        transport: { title: "Duerme a 100 m del tren", text: "Alójate junto a las estaciones de Renfe y FGC y muévete por Barcelona en 30 minutos. Mejor precio garantizado en la web oficial." },
        guides: { title: "Tu base para descubrir Martorell", text: "Barcelona, Montserrat y el aeropuerto a 30 minutos. Reserva directa y empieza a planear tu escapada." },
        business: { title: "Alojamiento y salas para tu empresa", text: "A 5 minutos de la zona industrial, con salas de reuniones y tarifa de empresa. Pídenos un presupuesto a medida." },
        default: { title: "Reserva tu estancia en Martorell", text: "Hotel 4★ a 30 minutos de Barcelona. Mejor precio garantizado reservando directamente." },
      },
    },
    homeHeadings: {
      presentation: ["Hotel 4 estrellas en Martorell.", "Descanso, trabajo y celebraciones", "a 30 minutos de Barcelona."],
      gastronomy: ["Cocina mediterránea", "de mercado, sin prisas"],
      extras: ["¿Un evento, una reunión", "o una estancia larga?"],
      heroRooms: "Habitaciones",
    },
  },
};

export default es;
